import React from 'react';
import ParkingMap from './components/ParkingMap';
import parkingData from './data/parkingData.json'; // ensure you have your JSON here
import 'leaflet/dist/leaflet.css';

function App() {
  return (
    <div className="App">
      <ParkingMap parkingData={parkingData} />
    </div>
  );
}

export default App;
